<template>
  <div>
    <app-title>
      Extensions - {{domain}}
      <v-btn color="secondary" @click="$router.go(-1)">Back</v-btn>
    </app-title>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>

      <v-container fluid>
        <v-layout row wrap>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
              <app-title>Edit {{selectedItemID}}</app-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field label="First Name" v-model="selectedExtension.first_name"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field label="Display Name" v-model="selectedExtension.display_name"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Email"
                        v-model="selectedExtension.email_address"
                        v-validate="'email-multiple'"
                        data-vv-as="Email"
                        :error-messages="errors.collect('email_field')"
                        name="email_field"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md9>
                      <v-text-field
                        label="Mobile Number"
                        v-model="selectedExtension.cell_dis"
                        :error-messages="errors.collect('cell_dis')"
                        name="cell_dis"
                        v-validate="'mobilenumber'"
                        data-vv-as="Mobile Number"
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        label="Voicemail"
                        v-model="selectedExtension.vm_indicator"
                        readonly
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch
                        color="success"
                        label="Do not disturb"
                        v-model="selectedExtension.dnd"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="cfa"
                        label="Call Forward (All Calls To)"
                        v-model="selectedExtension.cfa"
                        id="cfa"
                        :error-messages="errors.collect('cfa')"
                        data-vv-as="Call Forward (All Calls To)"
                        v-validate="'phonenumber'"
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="cfb"
                        label="Call Forward (Busy)"
                        v-model="selectedExtension.cfb"
                        id="cfb"
                        :error-messages="errors.collect('cfb')"
                        data-vv-as="Call Forward (Busy)"
                        v-validate="'phonenumber'"
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="cfn"
                        v-model="selectedExtension.cfn"
                        label="Call Forward (No Answer)"
                        id="cfn"
                        :error-messages="errors.collect('cfn')"
                        data-vv-as="Call Forward (No Answer)"
                        v-validate="'phonenumber'"
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="cfd"
                        v-model="selectedExtension.cfd"
                        label="Call Forward (Not Registered)"
                        id="cfd"
                        :error-messages="errors.collect('cfd')"
                        v-validate="'phonenumber'"
                        data-vv-as="Call Forward (Not Registered)"
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs10 font-weight-bold>Open for MAC provisioning</v-flex>
                    <v-flex xs2>
                      <v-btn
                        icon
                        large
                        class="mx-0"
                        @click="setExtensionForProvision(props.item)"
                        color="success"
                        title="Open for MAC provisioning"
                      >
                        <v-icon>settings_ethernet</v-icon>
                      </v-btn>
                    </v-flex>-->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="updateExtension" :disabled="errors.any()">Save</v-btn>
                <v-btn @click.native="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="extensions"
              :search.sync="search"
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <tr @click="editItem(props.item)">
                  <td
                    v-for="(item,index) in headers.filter(x => x.value !== 'actions')"
                    :key="index"
                    class="text-xs-center"
                    xs1
                  >
                    <div v-if="(item.text == 'Mobile Phone')">
                      <p
                        v-for="(num, numIndex) in props.item[item.value]"
                        :key="numIndex"
                      >{{num.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4')}}</p>
                    </div>
                    <p v-else>{{ props.item[item.value] }}</p>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import globalMixin from "@/mixins/globalMixin";
import { VodiaRequest } from "@/models/dealerPortal/VodiaRequest";
import { mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  mapNamptFields,
  mapNamptMultiRowFields
} from "@/store/modules/forms/nampt";

export default {
  name: "Extensions",
  mixins: [globalMixin],
  data() {
    return {
      dialog: false,
      pagination: {
        rowsPerPage: 10,
        descending: false
      },
      selectedExtension: {},
      selectedItemID: null,
      headers: [
        {
          text: "Account",
          value: "name",
          align: "center",
          sortable: true,
          class: "",
          width: ""
        },
        {
          text: "First Name",
          value: "first_name",
          align: "center",
          sortable: true,
          class: "",
          width: ""
        },
        {
          text: "Display Name",
          value: "display_name",
          align: "center",
          sortable: true,
          class: "",
          width: ""
        },
        {
          text: "Mobile Phone",
          value: "cells",
          align: "center",
          sortable: true,
          class: "",
          width: ""
        },
        {
          text: "Email",
          value: "email_address",
          align: "center",
          sortable: true,
          class: "",
          width: ""
        },
        {
          text: "Voicemail",
          value: "vm",
          align: "center",
          sortable: true,
          class: "",
          width: ""
        }
      ],
      extensions: [],
      selectedExtensionOriginal: {},
      selectedExtension: {},

      extensions: []
    };
  },
  computed: {
    ...mapNamptFields(["domain"])
  },
  mounted() {
    let vm = this;
    vm.getExtensions();
  },
  methods: {
    ...mapActions("nampt", [
      "getPBXExtensions",
      "saveExtension",
      "getPBXExtension",
      "provisionPBXExtension"
    ]),
    getExtensions() {
      let vm = this;
      let domainName = vm.domain;
      vm.getPBXExtensions(domainName).then(result => {
        vm.extensions = result.data;
      });
    },
    updateExtension() {
      let vm = this;

      vm.$validator
        .validateAll()
        .then(result => {
          if (result) {
            vm.dialog = false;
            //Since Vodia demands a string.
            vm.selectedExtension.dnd = vm.selectedExtension.dnd.toString();

            const request = {
              domainName: vm.domain,
              formerContent: vm.selectedExtensionOriginal,
              content: vm.selectedExtension,
              identifier: vm.selectedItemID
            };

            vm.saveExtension(request).then(result => {
              vm.getPBXExtensions(request.domainName).then(result => {
                vm.extensions = result.data;
                vm.selectedExtensionOriginal = {};
                vm.selectedExtension = {};
              });
            });
          }
        })
        .catch();
    },
    setExtensionForProvision(item) {
      let vm = this;
      // const data = {
      //   id: item.name,
      //   domainName: vm.$route.params.domain
      // };
      const data = {
        id: item.name,
        domainName: "500134.70.vonex.biz"
      };
      vm.provisionPBXExtension(data).then(result => {
        vm.getPBXExtensions(data.domainName).then(result => {
          vm.extensions = result.data;
        });
      });
    },
    editItem(item) {
      let vm = this;

      vm.selectedItemID = item.name;
      // Actual
      // var request = {
      //   domain: vm.$route.params.domain,
      //   id: vm.selectedItemID
      // };

      //Testing
      var request = {
        domain: vm.domain,
        id: vm.selectedItemID
      };

      vm.getPBXExtension(request).then(async result => {
        if (result) {
          vm.selectedExtensionOriginal = {
            display_name: result.data.display_name,
            cell_dis: result.data.cell_dis,
            cfa: result.data.cfa,
            cfb: result.data.cfb,
            cfd: result.data.cfd,
            cfn: result.data.cfn,
            dnd: result.data.dnd,
            first_name: result.data.first_name,
            email_address: result.data.email_address,
            vm_indicator: result.data.vm_indicator
          };
          vm.selectedExtension = Object.assign(
            {},
            vm.selectedExtensionOriginal
          ); //Create a copy for extension.
          vm.dialog = true;
        }
      });
    },
    close() {
      this.dialog = false;
      this.selectedExtensionOriginal = {};
      this.selectedExtension = {};
    },
    save() {
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>